import { Accordion, Button, Col, Fieldset, Form, FormCheckbox, Row, SectionPage } from '@snsw/react-component-library';
import React, { useState } from 'react';
import ScrollToTop from '../../../shared/utils/scrollToTop';
import styles from './PlantDesignBeforeYouStart.module.scss';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { PagePath } from 'shared/constants/pagePath';
import { storeSkipBeforeYouStartPage } from 'plantDesign/redux/plantDesignDesignApplicationSlice';
import { DownloadButton } from 'shared/components/downloadButton/DownloadButton';
import { PlantDesignConstants } from 'plantDesign/constants/plantDesignConstants';

export const PlantDesignBeforeYouStart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  ScrollToTop();
  const application = useSelector((state) => state.plantDesignApplication);

  const [skipThisPage, setSkipThisPage] = useState(application?.skipBeforeYouStartPage || false);

  const onStartClick = () => {
    dispatch(storeSkipBeforeYouStartPage(skipThisPage));
    navigate(PagePath.plantDesignWhatYouNeed);
  };

  return (
    <>
      <SectionPage>
        <Row>
          <Col span={9}>
            <h1 className={styles.pageTitle}>Before you start</h1>
            <p>
              Before you start your online application for plant design registration, you will need to complete these
              steps.
            </p>
          </Col>
        </Row>
      </SectionPage>
      <SectionPage className={styles.mainSection}>
        <Accordion type="step" theme={'blue'}>
          <Accordion.Tile title="Download and complete the statement" expanded>
            <p className={styles.noMarginT}>To complete the statement, you will need:</p>
            <ul>
              <li>contact details for the designer and design verifier</li>
              <li>design technical standards</li>
              <li>representational drawings</li>
              <li>engineering principles used in the design (if applicable)</li>
            </ul>
            <DownloadButton
              href={PlantDesignConstants.designerAndVerifierStatementUrl}
              label="Designer and Design verifier statement"
            />
          </Accordion.Tile>

          <Accordion.Tile title="Get the statement signed" expanded>
            <p className={styles.noMarginT}>The designer and design verifier will need to sign the statement.</p>
          </Accordion.Tile>

          <Accordion.Tile title="Check your documents are ready to upload" expanded>
            <p className={styles.noMarginT}>
              The statement and drawings can be JPG, PDF or PNG format. <br></br>File size must be less than 10MB.
            </p>
          </Accordion.Tile>
        </Accordion>
      </SectionPage>
      <SectionPage>
        <Form>
          <Fieldset legend="">
            <FormCheckbox
              id="selectionCheckBox"
              label="Skip this step next time I register a plant design"
              name="selectionCheckBox"
              onChange={(v) => {
                setSkipThisPage(v === 'true');
              }}
              value="true"
              checked={skipThisPage}
            />
          </Fieldset>
          <SectionPage className={styles.startBtn}>
            <Button onClick={() => onStartClick()}>Start your application</Button>
          </SectionPage>
        </Form>
      </SectionPage>
    </>
  );
};
